module.exports = __webpack_public_path__ + "static/media/organization--mobile--en.4a3b1062.png";